import React from 'react';
import { Progress } from 'reactstrap';
import { formatPercentageRounded } from 'services/NumberFormatters';

const MultiCellProgressBar = ({ data }) => {
    if (Array.isArray(data) && data.length > 3) {
        return (
            <Progress multi>
                <Progress bar color="danger" value={data[0] > 0 ? data[0] : 1}>
                    {data[0] > 0 ? formatPercentageRounded(data[0]) : ''}
                </Progress>
                <Progress bar color="warning" value={data[1] > 0 ? data[1] : 1}>
                    {data[1] > 0 ? formatPercentageRounded(data[1]) : ''}
                </Progress>
                <Progress bar value={data[2]}>
                    {data[2] > 0 ? formatPercentageRounded(data[2]) : ''}
                </Progress>
                <Progress bar color="success" value={data[3] > 0 ? data[3] : 1}>
                    {data[3] > 0 ? formatPercentageRounded(data[3]) : ''}
                </Progress>
            </Progress>
        );
    }
    return null;
};

export default MultiCellProgressBar;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurveyCompare/OrgSurveyCompareReports/OrgSurveyEngagementDetails/Components/MultiCellProgressBar.js